export default __webpack_public_path__ + "static/quanto-98285cb68df91576e660e947b59bde2b.png";